import { cva, type VariantProps } from 'class-variance-authority'

export { default as Badge } from './Badge.vue'

export const badgeVariants = cva(
  'inline-flex h-6 items-center justify-center select-none gap-2 whitespace-nowrap rounded-md px-2 label-xs has-[>.dot]:gap-1.5 bg-background text-text-sub-600 ',
  {
    variants: {
      variant: {
        default: 'bg-primary [a&]:hover:bg-primary/90',
        secondary: 'bg-secondary [a&]:hover:bg-secondary/90',
        destructive:
          ' bg-destructive [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60',
        outline: 'ring-1 ring-inset ring-stroke-soft-200'
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
)
export type BadgeVariants = VariantProps<typeof badgeVariants>
